<template>
  <div>
    <v-dialog v-model="dialog" max-width="900" style="overflow: hidden !important;">
      <v-card>
        <v-card-title> {{processType === "new" ? "Yeni Cari Hedefi Ekle" : "Cari Hedefini Düzenle"}}
          <v-spacer></v-spacer>
          <v-btn @click="closeDialog()" color="danger darken-1" style="color:white">
            KAPAT
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div class="container">
            <div class="row">
              <div class="col-lg-6">
                <v-select @input="$v.currentTarget.currentCode.$touch()" @blur="$v.currentTarget.currentCode.$touch()"
                          :error-messages=" validationMessages($v.currentTarget.currentCode, 'Cari') "
                          :disabled="processType === 'edit' "
                          v-model="currentTarget.currentCode" label="Cari" clearable dense filled solo placeholder=" "
                          :items="currentList" :item-text="item => item.name" :item-value="item => item.code">
                </v-select>
              </div>
              <div class="col-lg-6">
                <v-text-field solo dense filled v-model="currentTarget.targetLimit" placeholder="Hedef Limiti"
                              @input="$v.currentTarget.targetLimit.$touch()" @blur="$v.currentTarget.targetLimit.$touch()"
                              :error-messages=" validationMessages($v.currentTarget.targetLimit, 'Hedef') "></v-text-field>
              </div>
              <div class="col-lg-6">
                <v-menu transition="scale-transition"
                        offset-y :close-on-content-click="false"
                        min-width="auto">
                  <template v-slot:activator="{on,attrs}">
                    <v-text-field
                        @input="$v.currentTarget.startDate.$touch()"
                        @blur="$v.currentTarget.startDate.$touch()"
                        :error-messages="
                  validationMessages($v.currentTarget.startDate, 'Başlangıç tarihi')
                "
                        :value="formattedDate(currentTarget.startDate)"
                        label="Tarih Aralık Başlangıç"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        dense
                        filled
                        solo
                        placeholder=" "
                        clearable
                        @click:clear="currentTarget.startDate = null"
                        v-bind="attrs"
                        v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                      v-model="currentTarget.startDate"
                      locale="tr"
                  ></v-date-picker>
                </v-menu>
              </div>
              <div class="col-lg-6">
                <v-menu transition="scale-transition" offset-y :close-on-content-click="false" min-width="auto">
                  <template v-slot:activator="{on,attrs}">
                    <v-text-field
                        @input="$v.currentTarget.finishDate.$touch()"
                        @blur="$v.currentTarget.finishDate.$touch()"
                        :error-messages="
                  validationMessages($v.currentTarget.finishDate, 'Bitiş tarihi')
                "
                        :value="formattedDate(currentTarget.finishDate)"
                        label="Tarih Aralık Bitiş"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        dense
                        filled
                        solo
                        placeholder=" "
                        clearable
                        @click:clear="currentTarget.finishDate = null"
                        v-bind="attrs"
                        v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                      v-model="currentTarget.finishDate"
                      locale="tr"
                  ></v-date-picker>
                </v-menu>
              </div>
            </div>
          </div>
          <div class="d-flex">
            <v-spacer></v-spacer>
            <v-btn small class="me-1" color="secondary" @click="closeDialog()">İptal Et</v-btn>
            <v-btn small color="success" @click="saveTarget">Hedefi Oluştur</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {mapActions, mapState} from "vuex";
import {formattedDate} from "@/momentHelper";
import {required} from "vuelidate/lib/validators";
import {validationMessages} from "@/validationMessages";
import {validationMixin} from "vuelidate";
// import SearchSelect from "@/components/searchSelect.vue";

export default {
  mixins: [validationMixin],
  validations() {
    return {
      currentTarget: {
        startDate: {required},
        finishDate: {required},
        currentCode: {required},
        targetLimit: {required},
      }
    }
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    processType: {
      type: String,
      default: "new",
    },
    targetId: {
      type: Number,
      default: null,
    },
    targetProp: {
      type: Object,
      default: () => ({
        id: null,
        currentCode: null,
        targetLimit: null,
        startDate: null,
        endDate: null,
      }),
    },
  },
  name: "NewCurrentTargetDialog",
  data() {
    return {
      dialog: false,
      currentTarget: {
        currentCode: null,
        targetLimit: null,
        startDate: null,
        finishDate: null,
      },

    };
  },
  // components: {SearchSelect},
  computed: {
    ...mapState("auth",["user"]),
    ...mapState("current",["currentList"]),
  },
  mounted() {
    this.fetchCurrentList({
      params: {
        userId : this.user.UserId,
        pageNumber: 1,
        pageSize: 50,
        ...(this.user.RoleGroupId == "2" || this.user.RoleGroupId == 2  ? true : false) && {salesPersonCode: this.user.SalesPersonCode },
        ...(this.currentSearchText == "" || this.currentSearchText == null  ? false : true) && {searchText: this.currentSearchText }
      },
      body: {},
    })
  },
  methods: {
    formattedDate,
    validationMessages,
    ...mapActions("target",["currentTargetAdd","currentTargetUpdate"]),
    ...mapActions("current",["fetchCurrentList","fetchCurrentSingleTarget"]),
    async _fetchCurrentSingle() {
      let currentSingleResult = await this.fetchCurrentSingleTarget({
        params: {
          id: this.targetId
        },
        body: {}
      });
      if (currentSingleResult) {
        this.currentTarget.currentCode = currentSingleResult.currentCode;
        this.currentTarget.targetLimit = currentSingleResult.targetLimit;
        this.currentTarget.startDate = currentSingleResult.startDate;
        this.currentTarget.finishDate = currentSingleResult.finishDate;
      } else {
        this.currentTarget.currentCode = null;
        this.currentTarget.targetLimit = null;
        this.currentTarget.startDate = null;
        this.currentTarget.finishDate = null;
      }
    },
    async _currentTargetAdd() {
      await this.currentTargetAdd({
        params: {
          userId: this.user.UserId
        },
        body: {
          currentCode: this.currentTarget.currentCode,
          targetLimit: this.currentTarget.targetLimit,
          startDate: this.currentTarget.startDate,
          finishDate: this.currentTarget.finishDate,
        }
      });
    },
    async _currentTargetUpdate() {
      await this.currentTargetUpdate({
        params: {
          userId: this.user.UserId
        },
        body: {
          id: this.targetProp.id,
          targetLimit: this.currentTarget.targetLimit,
          startDate: this.currentTarget.startDate,
          finishDate: this.currentTarget.finishDate,
        },
        urlSegments: [],
      });
    },
    closeDialog() {
      this.dialog = false;
      this.$v.$reset();
    },
    async saveTarget() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.processType === 'new') {
          await this._currentTargetAdd();
          this.$parent._fetchCurrentTargetList();
          this.dialog = false;
        } else {
          await this._currentTargetUpdate();
        }
        this.currentTarget = {
          currentCode: null,
          targetLimit: null,
          startDate: null,
          finishDate: null,
        };
        this.closeDialog();
      }
    }
  },
  watch: {
    dialog: function (newVal) {
      this.$emit("dialogChange",newVal)
    },
    showDialog: function (newVal) {
      this.dialog = newVal
    },
    targetProp: function (newVal) {
      this.currentTarget = Object.assign({}, newVal);
    },
    'currentTarget.startDate': function(newStartDate,) {
      if (this.currentTarget.finishDate && newStartDate > this.currentTarget.finishDate) {
        this.currentTarget.finishDate = newStartDate;
      }
    },
    'currentTarget.finishDate': function(newFinishDate,) {
      if (this.currentTarget.startDate && newFinishDate < this.currentTarget.startDate) {
        this.currentTarget.startDate = newFinishDate;
      }
    }
  },

}
</script>

<style scoped>

</style>